// @ts-nocheck
import { populate } from 'populate';
import type { Container, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'a9c21f75-ec4e-4f09-9ccc-4c373ca6636c',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '98929f73-8e59-4644-93ad-56927f250076',
      type: 'Container',
      name: 'wrapper',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'a9c21f75-ec4e-4f09-9ccc-4c373ca6636c',
      data: {
        dynamicValues: {
          x: 'width * 0.5',
          y: 'height * 0.5'
        }
      }
    },
    {
      id: 'fcaf9d7b-0e0e-4a9c-8c9e-24224f92285d',
      type: 'Text',
      name: 'three',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '3',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 100,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 10,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '98929f73-8e59-4644-93ad-56927f250076'
    },
    {
      id: '103ddf83-9813-416f-8892-05ab027ddf2f',
      type: 'Text',
      name: 'two',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '2',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 100,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 10,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '98929f73-8e59-4644-93ad-56927f250076'
    },
    {
      id: '13053736-819f-4cd4-8dcc-83d2c5e07f95',
      type: 'Text',
      name: 'one',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '1',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 100,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 10,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '98929f73-8e59-4644-93ad-56927f250076'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '4.0.1',
  animations: [
    {
      id: 'e67f0621-0996-4f59-b031-eaba8ff0cb1b',
      name: 'Start',
      playingSpeed: 1,
      totalDuration: 1000,
      blocks: [
        {
          id: 'f5dabfb4-c053-440c-adcf-12edfb72d1e9',
          type: 'Setter',
          name: 'New_setter',
          track: 2,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 0,
          sourceName: 'three',
          disabled: false
        },
        {
          id: '29d92042-da8d-4337-99d6-2d30afec2ecd',
          type: 'Setter',
          name: 'New_setter_copy_1',
          track: 3,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 299,
          sourceName: 'two',
          disabled: false
        },
        {
          id: 'ad0154d2-6a71-4412-be67-611150231010',
          type: 'Setter',
          name: 'New_setter_copy',
          track: 2,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 299,
          sourceName: 'three',
          disabled: false
        },
        {
          id: '140a7041-751a-4500-a9df-10b5865b0daa',
          type: 'Setter',
          name: 'New_setter_copy_copy',
          track: 3,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 600,
          sourceName: 'two',
          disabled: false
        },
        {
          id: '779c88c7-3929-4d06-8659-43d160d6c01c',
          type: 'Setter',
          name: 'New_setter_copy_1_copy',
          track: 4,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 601,
          sourceName: 'one',
          disabled: false
        },
        {
          id: 'f4422c09-aa6a-498b-a907-27cd97a0a128',
          type: 'Setter',
          name: 'New_setter_copy_copy_copy',
          track: 4,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 901,
          sourceName: 'one',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class VersusCountdownLayout {
  static raw = raw;
  root!: Container;
  wrapper!: Container & { data: typeof raw['list'][1]['data'] };
  three!: Text;
  two!: Text;
  one!: Text;
  dynamicProps_SPL!: (Container & { data: typeof raw['list'][1]['data'] })[];
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class Start {
  Layout: {
    three: object;
    two: object;
    one: object;
  };

  BlockTypeByName: {
    New_setter: object;
    New_setter_copy_1: object;
    New_setter_copy: object;
    New_setter_copy_copy: object;
    New_setter_copy_1_copy: object;
    New_setter_copy_copy_copy: object;
  };

  flowData = raw.animations[0];
}
